import Vue from 'vue'
import Hotjar from 'vue-hotjar'

Vue.use(Hotjar, {
  id: '276973',
})
